export default function getTreksFactory(ajax, getSession) {
  return async function getTreks(count = -1, page = 0) {
    return ajax('getTreks', { count, page });
  };
}



// WEBPACK FOOTER //
// ./src/services/getTreks.js